<dx-popup
  [visible]="showModal"
  [showTitle]="true"
  [title]="'COMMON.CONFIRM' | translate"
  [width]="popupWidth"
  [height]="'auto'"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  (onHidden)="close()"
>
    <div>
        <div class="text-center">
            <ng-container *ngIf="confirmationResultModel.isConfirmed">
                <ng-container *ngIf="!confirmationResultModel.eSignatureAlreadyExists; else eSignatureAlreadyExistsTemplate">
                    <p class="response-message">{{ 'CONFIRMATION.PARTICIPATION-CONFIRMED-SUCCESSFULLY' | translate }}</p>
                </ng-container>
                <ng-template #eSignatureAlreadyExistsTemplate>
                    <p class="response-message">{{ 'CONFIRMATION.ESIGNATURE-ALREADY-EXISTS' | translate }}</p>
                </ng-template>
            </ng-container>
        </div>
    </div>
</dx-popup>